// units.ts
export enum Units {
  BarrelsPerDay = 'bbl/d', // barrels per day
  BarrelsOfOilEquivalentPerDay = 'boe/d', // barrels of oil equivalent per day
  MillionBarrels = 'MMbbl', // million barrels
  BillionCubicFeet = 'Bcf', // billion cubic feet
  MillionCubicFeetPerDay = 'MMcf/d', // million cubic feet per day
  EmissionsKgCo2PerBoe = 'kgCO2/boe', // kilograms CO2 per barrel of oil equivalent
  UsDollarMillions = 'US$MM', // U.S. dollars (millions)
  DollarsPerBarrel = '$/bbl', // dollars per barrel
  MillionBoe = 'MMboe', // million barrels of oil equivalent
}

export enum HydrocarbonType {
  Oil = 'oil',
  Gas = 'gas',
}
